
const Str2DateWithDot = (dateString) => {
    if (!dateString) return null;
    if (typeof dateString == "string") {
      const [datePart, timePart] = dateString?.split(" ");
      const [year, month, day] = datePart?.split("/");
      return `${year}.${month}.${day}`
    }
    return dateString;
  };
  export default Str2DateWithDot;
  